
    import '/opt/buildhome/repo/components/x-request/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["components-x-request-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/x-request/index.en-US.md?type=demo')
};